import { AxiosRequestConfig } from 'axios'
import { Toast, Dialog } from 'vant'
import store from '@/store'
import service from './axios'
import { getToken, getCsrfToken, removeToken } from '@/utils/auth'
import { checkToken, cGoBack } from '@/utils/const'
interface BaseResponse<T> {
  code: number
  status: boolean
  data: T
  message?: string
  body: T
  header: {
    [key: string]: string | number
  }
}

const request = <T>(config: AxiosRequestConfig): Promise<BaseResponse<T>> => {
  return new Promise((resolve, reject) => {
    service.request<BaseResponse<T>>(config).then(
      res => {
        resolve(res.data)
      },
      err => {
        
        reject(err)
      }
    )
  })
}

export default request
